import COMMON from '../common/routes';
import NUTZUNGSARTEN from '../nutzungsarten/routes';
import QUALITAETSWEINPRUEFUNG from '../qualitaetsweinpruefung/routes';
import PFLANZGENEHMIGUNGEN from '../rebflaechen/pflanzgenehmigungen/routes';
import REBFLAECHEN from '../rebflaechen/routes';
import UMSTRUKTURIERUNGSANTRAG from '../umstrukturierungsantrag/routes';
import FERTIGSTELLUNGSMELDUNG from '../umstrukturierungsantrag/fertigstellungsmeldung/routes';
import VERMARKTUNGSRECHTE from '../vermarktungsrechte/routes';
import WIPZN from '../wipzn/routes';
import BETRIEB from '../betrieb/routes';
import USER from '../user/routes';
var appContainer = document.getElementById('app');
var getApiPrefix = function () { return appContainer === null || appContainer === void 0 ? void 0 : appContainer.getAttribute('data-api-host'); };
var routeConfig = {
    prefix: {
        PAGE: {
            REBFLAECHEN: '/wip40/rv/betrieb/:betrieb_nr',
            PFLANZGENEHMIGUNGEN: '/wip40/gr/betrieb/:betrieb_nr',
            VERMARKTUNGSRECHTE: '/wip40/vm/betrieb/:betrieb_nr',
            UMSTRUKTURIERUNGSANTRAG: '/wip40/foerderung/betrieb/:betrieb_nr',
            FERTIGSTELLUNGSMELDUNG: '/wip40/foerderung/fm',
            QUALITAETSWEINPRUEFUNG: '/wip40/qp/betrieb/:betrieb_nr',
            NUTZUNGSARTEN: '/wip40/na',
            WIPZN: '/wip40/wipzn',
            BETRIEB: '/wip40/betrieb/:betrieb_nr',
            USER: '/wip40/user',
            COMMON: '/wip40',
        },
        API: getApiPrefix(),
        CMSFILE: 'https://wip.lwk-rlp.de/cms/fileadmin/wip30_live_documents',
    },
    modules: [
        REBFLAECHEN,
        PFLANZGENEHMIGUNGEN,
        VERMARKTUNGSRECHTE,
        UMSTRUKTURIERUNGSANTRAG,
        FERTIGSTELLUNGSMELDUNG,
        QUALITAETSWEINPRUEFUNG,
        NUTZUNGSARTEN,
        WIPZN,
        BETRIEB,
        USER,
        COMMON,
    ],
};
export default routeConfig;
